goog.provide('el8.appchart.dialog.addEditPatientTags');

goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.addEditTags');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


el8.appchart.dialog.addEditPatientTags = (function() {

    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Patient Chart Tags',
        modal: false,
        autoHeight: true,
        width: 400,
        contentFn: el8.template.appchart.dialog.addEditTags.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'tags',
                selector: '.tags-holder',
                infoText: 'Add tags...',
                maxLength: 100,
                tagInputOpts: {
                    mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.availablePtTags(), {
                        containerLeftOffset: 10
                    }),
                    promptCreateTagFn: function(val, handleTagItemFn) {
                        if (!val) { return; }

                        var confirmMsg = 'Are you sure you want to create a new tag called "' +
                            val + '"? Creating a new tag will add it to your Patient Tags Settings page.';
                        var createTagFn = function() {
                            var tag = el8.ptdata.ptTags.create({ value: val });
                            el8.ptdata.ptTags.saveItem(tag, false, {
                                successCb: function() {
                                    handleTagItemFn(tag.asSoyMap());
                                }
                            });
                        };
                        el8.uiwidget.confirm(confirmMsg, createTagFn);
                    },
                    convertTextToItemFn: function(val, handleTagItemFn, handleEmptyItemFn) {
                        if (!val) { return; }

                        $.el8_ajax({
                            url: el8.service.urls.get('availablePtTags'),
                            data: { 'value': val},
                            success: function(data) {
                                if (data) {
                                    var tag = el8.ptdata.ptTags.create(data);
                                    handleTagItemFn(tag.asSoyMap());
                                } else {
                                    handleEmptyItemFn();
                                }
                            }
                        });
                    }
                }
            }
        ]
    });
    form.addSaveButton(function() {
        doSave();
    }, true);
    form.addDiscardChangesButton(function() {
        that.hide();
    });
    that.setForm(form);

    function doSave() {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('updatePatientTags'),
            data: JSON.stringify(form.getMapped()),
            success: function(data) {
                el8.ptdata.ptTags.create(data);
                el8.ptdata.currPatient.setTagIds(_.pluck(data, 'id'));
                el8.appchart.refpanel.tags.show();
                that.hide();
            }
        });
    }

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);

        var tagInput = form.getTagInput('tags');
        var tags = el8.ptdata.currPatient.getTags();
        tagInput.setTags(tags.map(el8.model.toSoyMapFn));
        form.focusField('tags');
    };

    return that;

})();
